import type { FC } from 'react';
import { Form, type FormControlProps } from 'react-bootstrap';
import type { FormProps } from 'react-router-dom';

import { Icon } from '../../Menu/Icon';

import './styles/styles.css';

export const SearchTableInput: FC<FormControlProps> = ({ onInput, ...rest }) => {
  return (
    <Form className="inbox-search d-flex align-items-center">
      <Icon iconName="Search" size={12} className="align-top search-icon" />

      <Form.Control
        className="me-2 search-input"
        type="text"
        placeholder={rest.placeholder || 'Search'}
        value={rest.value}
        onInput={onInput}
        {...rest}
      />
    </Form>
  );
};

export const SearchInboxInput: FC<FormProps> = ({ ...rest }) => {
  return (
    <Form className="inbox-search d-flex align-items-center" {...rest}>
      <Icon iconName="Search" size={12} className="align-top search-icon" />
      <Form.Control
        type="search"
        placeholder={rest.placeholder || 'Search'}
        className="me-2 search-input"
      />
    </Form>
  );
};

export const SearchInput: FC<FormProps> = ({ ...rest }) => {
  return (
    <Form className="table-search d-flex align-items-center" {...rest}>
      <Icon iconName="Search" size={12} className="align-top search-icon" />
      <Form.Control
        type="search"
        placeholder={rest.placeholder || 'Search'}
        className="me-2 search-input"
      />
    </Form>
  );
};

export const DashboardSearchInput: FC<FormProps> = ({ className, ...rest }) => {
  return (
    <Form className="d-flex article-search-form align-items-center" {...rest}>
      <Icon iconName="Search" size={18} className="align-top search-icon" />
      <Form.Control
        type="search"
        placeholder="Search Article"
        className="me-2 article-search-input"
        aria-label="Search"
      />
    </Form>
  );
};
